export const content = {
  title: 'Рейтинги вузов',
  seo: {
    meta: {
      title:
        'Рейтинг вузов России 2024-2025, ТОП российских университетов по качеству образования — Учёба.ру',
      description:
        'Лучшие российские университеты и их позиции в самых авторитетных международных рейтингах вузов: рейтинг вузов России RAEX-2024, QS World University Rankings-2025 , ShanghaiRanking’s Academic Ranking of World Universities-2024, Times Higher Education World University Rankings-2025.',
    },
  },
}
